// src/app/providers.tsx
'use client';

import { I18nextProvider } from 'react-i18next';
import i18n from '../i18n';
import type { ReactNode } from 'react';

interface ProvidersProps {
  children: ReactNode;
}

const ProviderI18 = ({ children }: ProvidersProps) => {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};

export default ProviderI18;
